var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart-card',{attrs:{"size":_vm.size,"title":"시설물 점검 현황","value":_vm.data,"init-total":_vm.total,"unit":"건","isMoveWrite":_vm.isMoveWrite,"orientation":_vm.orientation},on:{"detail":_vm.onClickDetail,"write":_vm.onClickWrite}})
}
var staticRenderFns = []

export { render, staticRenderFns }